jQuery(document).on('click', 'a[href^="#"],a[href^="'+window.location.origin + window.location.pathname+'#"]', function (e) {
    e.preventDefault();

    var href = jQuery(this).attr('href');
    var hrefHashPos = href.indexOf('#');
    var hash = href.substring(hrefHashPos);

    if (hash.length === 1) {
        return;
    }

    var id = jQuery(hash);

    if (hash === '#main') {
        id = jQuery('main');
    }

    if (id.length === 0) {
        return;
    }

    var headerHeight = jQuery('#site-header').outerHeight() * 1.2;
    var offset = id.offset().top - headerHeight;

    if (id.prop('nodeName').toLowerCase() === 'main') {
        id.focus();
        return;
    }

    if (jQuery('body').hasClass('admin-bar')) {
        offset -= 32;
    }

    if (jQuery(id).hasClass('ui-tabs-panel')) {
        offset -= 50;
    }

    jQuery('body, html').stop().animate({scrollTop: offset});
});
